/* eslint-disable new-cap */
import React from 'react';
import PropTypes from 'prop-types';

import { Td, Tr } from './css';

const TableBody = ({ keys, data, actions, dataModel, currentPage, step }) => (
  <tbody>
    {data.map((row, rowIndex) => {
      const rowData =
        (dataModel && dataModel.length && new dataModel(row)) || row;
      const rowKey = `row${rowIndex}`;
      return (
        <Tr key={rowKey} isOdd={rowIndex % 2}>
          <Td>{(currentPage - 1) * step + rowIndex + 1}</Td>
          {keys.map((cell, cellIndex) => {
            const cellKey = `cell${rowIndex}.${cellIndex}`;
            return cell !== 'actions' ? (
              <Td key={cellKey}>{rowData[cell]}</Td>
            ) : (
              <Td actionStyles key={cellKey}>
                {actions(row)}
              </Td>
            );
          })}
        </Tr>
      );
    })}
  </tbody>
);

TableBody.propTypes = {
  keys: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  actions: PropTypes.func.isRequired,
  dataModel: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  currentPage: PropTypes.number.isRequired,
  step: PropTypes.number.isRequired
};

TableBody.defaultProps = {
  dataModel: {}
};

export default TableBody;
